export default __webpack_public_path__ + "static/media/fraud-alerts.d6ae1135.svg";